<template>
		<ModelForm
			:modelId="modelId"
			resource="zoned-areas"
			:modelInfo="defaultModelInfo"
			v-slot="slotProps"
			@fetch="$emit('update:unableEdit',!$hasPermission('zone.edit'))"
			:successCallback="successCallback"
		>
			<b-form-row>
					<b-form-group :disabled="unableEdit" class="col-4" label="Nombre">
						<b-form-input type="text" size="sm" v-model="slotProps.modelInfo.name" required />
					</b-form-group>
					<b-form-group :disabled="unableEdit" class="col-4" label="Zonificacion">
						<b-form-select size="sm" v-model="slotProps.modelInfo.zonesType" :options="zonesTypeOptions"></b-form-select>
					</b-form-group>
				<b-form-group :disabled="unableEdit" class="col-4 pl-3 pt-4" label="">
					<b-form-checkbox v-model="slotProps.modelInfo.masterArea">
						Zona Shuttle Central
					</b-form-checkbox>
				</b-form-group>
			</b-form-row>
			<b-form-row>
					<b-form-group :disabled="unableEdit" class="col-8" label="Descripcion">
						<b-textarea size="sm" v-model="slotProps.modelInfo.description" />
					</b-form-group>
			</b-form-row>
			<hr>
			<div class="text-right">
				<b-button :disabled="unableEdit" variant="primary" type="submit">{{modelId>0?'Actualizar':'Guardar'}}</b-button>
			</div>
		</ModelForm>
</template>

<script>
import ModelForm from '../../helpers/ModelForm.vue'

export default {
	props: {
		unableEdit: Boolean,
		modelId: {
			type : Number,
			required: false,
			default:-1
		},
		modalId: {
			type : String,
			required: true,
		},
	},
	components: { ModelForm },
	data(){
		return {
			loading:true,
			defaultModelInfo:{
				id:-1,
				name:'',
				currency:'mxn',
				zonesType:'polygon',
				description:'',
				status:'active',
				masterArea: false,
			},
			currencyOptions : [
				{value:'mxn',text:'MXN'},
				{value:'usd',text:'USD'}
			],
			zonesTypeOptions : [
				{value:'polygon',text:'Polígonos en mapa'},
				{value:'postalCode',text:'Códigos postales'}
			],
		}
	},
	computed: {
	},
	methods:{
		successCallback(event){
			if(event.data?.id)this.$emit('modal-id',event.data.id)
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['zonedAreasOpts'], forceRefresh: true})
		}
	},
	mounted(){
	}
}
</script>

<style>

</style>
